import axios from 'axios';
import { getHeaders } from '../lib/requests';

export async function fetchDeliveries(page, pageSize, additionalParams = {}) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const params = { page, pageSize, ...additionalParams };
        const response = await axios.get(`${apiUrl}/deliveries`, {
            headers: getHeaders(apiToken),
            params,
        });

        return {
            deliveries: response.data.data,
            totalPages: response.data.totalPages,
            totalRecords: response.data.total,
        };
    } catch (error) {
        console.error("Error fetching deliveries:", error);
        throw error;
    }
}

export async function fetchDelivery(deliveryId) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/deliveries/${deliveryId}`, {
            headers: getHeaders(apiToken),
        });

        return response.data.data;
    } catch (error) {
        console.error("Error fetching delivery:", error);
        throw error;
    }
}

export async function fetchDeliveriesByClientId(clientId, startDate, endDate) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/deliveries`, {
            headers: getHeaders(apiToken),
            params: {
                client_id: clientId,
                scheduled_delivery_date_start: startDate,
                scheduled_delivery_date_end: endDate,
            },
        });

        return response.data.data;
    } catch (error) {
        console.error("Error fetching deliveries by client ID:", error);
        throw error;
    }
}

export async function fetchDeliveriesForCustomer() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/my-deliveries`, {
            headers: getHeaders(apiToken),
        });

        return response.data.data;
    } catch (error) {
        console.error("Error fetching deliveries for customer:", error);
        throw error;
    }
}

export async function fetchClientsForRoute(routeId) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiToken = localStorage.getItem('accessToken');
    try {
        const response = await axios.get(`${apiUrl}/routes/${routeId}/clients`, {
            headers: getHeaders(apiToken),
        });

        return response.data.data;
    } catch (error) {
        console.error("Error fetching clients for route:", error);
        throw error;
    }
}